import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useContext } from 'react';
import unProtectedRoutes from './routers/unProtected';
import Whatsapp from './components/Whatsapp/Whatsapp';
import admin from './routers/admin';
import protectedRoutes from './routers/protected';
import RequiredAuth from './store/RequiredAuth'
import { GlobalContext } from './store/GlobalContext';

function App() {
  const { state } = useContext(GlobalContext);
  const userRoles: string[] = Array.isArray(state?.auth?.user?.roles) ? state.auth.user.roles : [];
  const isAdminUser = userRoles.includes('store_admin') || userRoles.includes('super_admin');

  return (
    <>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route>
            {unProtectedRoutes?.map((elem, index) => <Route path={elem?.path} element={elem?.element} key={index} />)}
          </Route>
          <Route element={<RequiredAuth />} >
            {protectedRoutes?.map((elem, index) => <Route path={elem?.path} element={elem?.element} key={index} />)}
          </Route>
          <Route element={<RequiredAuth allowedRoles={['store_admin', 'super_admin']} />}>
            {admin?.map((elem, index) => <Route path={elem?.path} element={elem?.element} key={index} />)}
          </Route>
        </Routes>
      </BrowserRouter >
      {!isAdminUser && <Whatsapp />}
    </>
  );
}

export default App;
